__turbopack_context__.v({
  "iconButton": "IconButton-module__rm2t_G__iconButton",
  "md": "IconButton-module__rm2t_G__md",
  "sm": "IconButton-module__rm2t_G__sm",
});
